@if (registrationStatus$ | async; as registrationStatus) {
    @if (row()) {
        <div
            priva-card
            [hasHeader]="false"
            [hasBody]="true"
            [hasFooter]="false"
            headerSize="md"
            (click)="toggleRowSelectionAndFinishIfSingleSelection()"
            (contextmenu)="onContextMenu($event)"
            size="xs"
            [class]="
                'row row--status-' +
                registrationStatus +
                ' row-' +
                ((isRowSelected$ | async) ? 'selected' : 'default')
            "
            id="row-{{ row().number }}"
            data-test="map-row"
        >
            <div class="buttons-wrapper">
                <button
                    priva-button
                    iconState="left"
                    class="for-registered-row row-name"
                    [iconClass]="getIconClassForRegistrationStatus(registrationStatus)"
                    importance="tertiary"
                >
                    {{ row().name }}
                </button>
                <button
                    priva-button
                    iconState="none"
                    class="for-not-registered-row row-name"
                    importance="tertiary"
                >
                    {{ row().name }}
                </button>
                @if (isMultiSelectModeAllowed$ | async) {
                    <button
                        priva-button
                        iconClass="fas fa-ellipsis-vertical"
                        iconState="only"
                        importance="tertiary"
                        (click)="onMenuButtonClicked($event)"
                        data-test="map-row-menu-button"
                    ></button>
                }
            </div>
        </div>
    }
}
